import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { ContextPageData } from '../../../context/PageData/index.js';
import { DesktopNav } from './components/DesktopNav/index.js';
import { MobileTabletNav } from './components/MobileTabletNav/index.js';
export const Nav = (props) => {
    const { viewer } = React.useContext(ContextPageData);
    const location = useLocation();
    const nav = React.useMemo(() => {
        return props.getConfig({
            viewer,
            get_started_completed: !location.pathname.includes(rootRoutes.sc.getStarted.main.get()),
        });
    }, [viewer, location.pathname]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'hidden md:flex', children: _jsx(DesktopNav, { config: nav.desktop }) }), _jsx("div", { className: 'md:hidden', children: _jsx(MobileTabletNav, { config: nav.mobile_tablet }) })] }));
};
//# sourceMappingURL=index.js.map